import React, { useEffect } from 'react';
import { useLanguage } from '../../../hooks/useLanguage';
import { aside as frAside } from '../../../locales/fr/aside';
import { aside as arAside } from '../../../locales/ar/aside';
import { aside as esAside } from '../../../locales/es/aside';
import useMyAppStore from '../../../stores/myAppStore';
import ActivitySettingsService from '../../../services/AppDataServices/services/ActivitySettings.service';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const Dashboard = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { 
    setPageTitle, 
    currentSale, 
    isLoading, 
    error, 
    lastSync, 
    pageTitle, 
    theme, 
    currentActivity, 
    activitySettings, 
    selectedLayout, 
    currentUser 
  } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.dashboard);
  }, [lang, t.routes.dashboard, setPageTitle]);

  const logGlobalState = () => {
    console.log('=== ÉTAT GLOBAL DU STORE ===');
    console.log('📊 currentSale:', currentSale);
    console.log('⏳ isLoading:', isLoading);
    console.log('❌ error:', error);
    console.log('🕒 lastSync:', lastSync);
    console.log('📄 pageTitle:', pageTitle);
    console.log('🎨 theme:', theme);
    console.log('🏢 currentActivity:', currentActivity);
    console.log('⚙️ activitySettings:', activitySettings);
    console.log('🎯 selectedLayout:', selectedLayout);
    console.log('👤 currentUser:', currentUser);
    console.log('===========================');
  };

  const cleanDuplicateSettings = async () => {
    try {
      console.log('🧹 Début du nettoyage des doublons...');
      const result = await ActivitySettingsService.cleanDuplicateSettings();
      console.log('✅ Nettoyage terminé:', result);
      alert('Nettoyage des doublons terminé ! Vérifiez la console pour plus de détails.');
    } catch (error) {
      console.error('❌ Erreur lors du nettoyage:', error);
      alert('Erreur lors du nettoyage des doublons !');
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          {lang === 'ar' ? 'لوحة التحكم' : 'Tableau de bord'}
        </h2>
        <div className="flex gap-2">
          <button
            onClick={logGlobalState}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            📊 Log State Global
          </button>
          <button
            onClick={cleanDuplicateSettings}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            🧹 Nettoyer Doublons
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Statistiques */}
        <div className="bg-blue-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-900">
            {lang === 'ar' ? 'النشاطات' : 'Activités'}
          </h3>
          <p className="text-3xl font-bold text-blue-600">0</p>
        </div>
        <div className="bg-green-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-green-900">
            {lang === 'ar' ? 'المستخدمين' : 'Utilisateurs'}
          </h3>
          <p className="text-3xl font-bold text-green-600">0</p>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-purple-900">
            {lang === 'ar' ? 'المنتجات' : 'Produits'}
          </h3>
          <p className="text-3xl font-bold text-purple-600">0</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 